import { createSelector } from "@reduxjs/toolkit";

const selectContactAttributes = (state: RootState) => state.contactAttributes.contactAttributes;

export const selectSortedContactAttributes = createSelector(selectContactAttributes, (contactAttributes) =>
    Object.values(contactAttributes).sort(({ attributeIndex: a }, { attributeIndex: b }) => (a ?? 0) - (b ?? 0))
);
